module.exports = __webpack_public_path__ + "static/media/004_Color Palette @2x.a80f32e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/backtrace/004_Color Palette @2x.png
// module id = 369
// module chunks = 0